import React from 'react';
import {tid} from '../../../../../testUtils';
import SideBarButtonItem from '../../../../layout/common/SideBarButtonItem';
import {SUBMODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import {ScenarioActionProps} from '../../../actionMenuTypes';
import useScenarioUnacceptSideBarModal from './useScenarioUnacceptSideBarModal';
import {canUnacceptInstance} from '../../../../../permissions/usePermissions';
import {Error16} from '@carbon/icons-react';

const ScenarioUnacceptActionMenuButton: React.FC<Partial<ScenarioActionProps>> = (props) => {
  const {ModalComponent, openModal} = useScenarioUnacceptSideBarModal(props);

  return (
    <>
      <SideBarButtonItem
        {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_UNACCEPT)}
        permission={canUnacceptInstance(props.model, props.subModel, props.scenario)}
        onClick={openModal}
        icon={<Error16 />}
        text="Unaccept"
      />
      {ModalComponent}
    </>
  );
};

export default ScenarioUnacceptActionMenuButton;
